import { NzUploadFile } from "ng-zorro-antd/upload";

export function validateUploadFile(file: NzUploadFile, maxSize: number) {
    const isLtMaxSize = file.size! <= maxSize;
    let message = undefined;
    if (!isLtMaxSize) {
        message = `上传文件不可以超过${maxSize / 1024 / 1024}MB!`;
    }
    return {
        valid: isLtMaxSize,
        message: message
    };

}